export default __webpack_public_path__ + "static/media/teacher4.14e1591b.png";